
    require('./gauge/GaugeSeries');
    require('./gauge/GaugeView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/gauge.js
// module id = 1129
// module chunks = 158